import {Injectable} from '@angular/core';
import {DeviceDetectorService} from "ngx-device-detector";
import {constants} from "../constants";

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private deviceDetectorService: DeviceDetectorService) {
  }

  get mainPageMelodiesSize(): number {
    if (this.deviceDetectorService.isDesktop()) {
      return constants.mainPageMelodiesPageSize.desktop;
    } else {
      return constants.mainPageMelodiesPageSize.other;
    }
  }

  get artistPageMelodiesSize(): number {
    if (this.deviceDetectorService.isDesktop()) {
      return constants.artistMelodiesPageSize.desktop;
    } else {
      return constants.artistMelodiesPageSize.other;
    }
  }

  get melodyPageMelodiesSize(): number {
    if (this.deviceDetectorService.isDesktop()) {
      return constants.melodyPageMelodiesPageSize.desktop;
    } else {
      return constants.melodyPageMelodiesPageSize.other;
    }
  }

  get genresPageMelodiesSize(): number {
    if (this.deviceDetectorService.isDesktop()) {
      return constants.genreMelodiesPageSize.desktop;
    } else if (this.deviceDetectorService.isTablet()) {
      return constants.genreMelodiesPageSize.tablet;
    } else {
      return constants.genreMelodiesPageSize.mobile;
    }
  }

  get searchMelodiesSize(): number {
    if (this.deviceDetectorService.isDesktop()) {
      return constants.searchMelodiesPageSize.desktop;
    } else {
      return constants.searchMelodiesPageSize.other;
    }
  }

  get searchArtistsSize(): number {
    if (this.deviceDetectorService.isDesktop()) {
      return constants.searchArtistsPageSize.desktop;
    } else {
      return constants.searchArtistsPageSize.other;
    }
  }
}
